import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GET_TELEGRAM_BOT_CONFIGS,
  ADD_TELEGRAM_BOT_CONFIG,
  GET_TELEGRAM_CONTACTS,
  GET_TELEGRAM_MESSAGES,
  SEND_TELEGRAM_MESSAGE,
  POST_RESET_UNREAD_COUNT,
} from '../../api/telegram.service';

// ----------------------------------------------------------
// Fetch all Telegram Bot Configs
// ----------------------------------------------------------
export const getTelegramBotConfigs = createAsyncThunk(
  'telegram/getBotConfigs',
  async ({ page = 0, limit = 10 }, thunkAPI) => {
    try {
      const response = await GET_TELEGRAM_BOT_CONFIGS(page, limit);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

// ----------------------------------------------------------
// Add Telegram Bot Config (Add Bot Token)
// ----------------------------------------------------------
export const addTelegramBotConfig = createAsyncThunk(
  'telegram/addBotConfig',
  async ({ token }, thunkAPI) => {
    try {
      const response = await ADD_TELEGRAM_BOT_CONFIG(token);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

// ----------------------------------------------------------
// Fetch Telegram Contacts
// ----------------------------------------------------------
export const getTelegramContacts = createAsyncThunk(
  'telegram/getContacts',
  async ({ botConfigId, page = 0, limit = 10, globalFilter }, thunkAPI) => {
    try {
      const response = await GET_TELEGRAM_CONTACTS(botConfigId, page, limit, globalFilter);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

// ----------------------------------------------------------
// Fetch Telegram chat messages
// ----------------------------------------------------------
export const getTelegramMessages = createAsyncThunk(
  'telegram/getMessages',
  async ({ botConfigId, chatId, lastMessageId = 0, limit = 10 }, thunkAPI) => {
    try {
      const response = await GET_TELEGRAM_MESSAGES(botConfigId, chatId, lastMessageId, limit);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

// ----------------------------------------------------------
// Send Telegram Message
// ----------------------------------------------------------
export const sendTelegramMessage = createAsyncThunk(
  'telegram/sendMessage',
  async ({ botConfigId, payload }, thunkAPI) => {
    try {
      const response = await SEND_TELEGRAM_MESSAGE(botConfigId, payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const resetUnreadCount = createAsyncThunk(
  'telegram/resetUnreadCount',
  async ({ botConfigId, chatId }, thunkAPI) => {
    try {
      const response = await POST_RESET_UNREAD_COUNT(botConfigId, chatId);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);
